class CreditoGeradoController extends AbstractController
  @$inject = ['$injector', '$uibModal', '$scope', '$filter', 'timeService', 'pathService','creditoGeradoService']

  constructor: ($injector, @modal, scope, @filter, @timeService, @pathService, @creditoGeradoService) ->
    super($injector)

    @contratoId = scope.tabData.contratoId

    @loadingTracker = @promiseTracker()
    @consulta = false
    @filtro =
      select_type: 'select_operacao'

    @listOfTypes = [
      {id: 'select_operacao', nome: 'Visualizar por operação'}
      {id: 'select_natureza', nome: 'Visualizar por natureza'}
      {id: 'select_item', nome: 'Visualizar por item'}
    ]

    @loadingTracker.addPromise @timeService.getList((retorno)=>
      atual = new Date(retorno.dataAtual)
      @filtro.mes = "#{atual.getMonth()+1}"
      @filtro.ano = atual.getFullYear()
    )

  hasAcesso: (empresa) -> 
    empresa.ferramentasDisponiveis.includes("detalhamento-creditos-pis-cofins")

  updateFilter: () ->
    @filtro.contrato = @empresaSelecionada.id

  consultar: (form) ->
    if !form.$valid
      return

    if @empresaSelecionada.pisCofins 
      filtro = angular.copy @filtro

      @listOfCreditoGerado = []

      if (filtro.mes? or filtro.numeroNfe?)?
        @loadingTracker.addPromise @creditoGeradoService.search(
          filtro, (result) =>
            @consulta = true
            @listOfCreditoGerado = result.data
        )
    else
       Confirm.warning(
          'Atenção',
          'A funcionalidade exige que a empresa possua parâmetros de PIS/COFINS configurados. Deseja configurá-los agora?',
          {
            'Não': angular.noop,
            'Sim': () => 
                @modal.open({
                  component: 'configuracaoPisCofinsModal',
                  size: 'lg',
                  keyboard: 'static',
                  resolve: {
                      empresaId: () => @empresaSelecionada.id
                  }
                })
                  .result.then((result) => 
                    result && @empresaSelecionada.pisCofins = result  
                  )
          }          
        )

      

  imprimir: ->
    url = "/api/eficiencia-fiscal/credito-gerado.pdf"

    cbk.download @pathService.parametrize(url, angular.copy(@filtro))


angular.module("eficienciaFiscalModule").controller('creditoGeradoController', CreditoGeradoController)
